import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';

//@ts-ignore
import App from './App.vue';
import { router } from './helpers';
import { useAuthStore } from './stores';

// setup fake backend
// import { fakeBackend } from './helpers';
// fakeBackend();

startApp();

// async start function to enable waiting for refresh token call
async function startApp() {
	const app = createApp(App);
	const i18n = createI18n({
		legacy: false,
		availableLocales: ['en-US']
	});

	const { VITE_ENV } = import.meta.env;

	app.use(createPinia());
	app.use(router);
	app.use(PrimeVue, {});
	app.use(ConfirmationService);

	app.config.errorHandler = (err, vm, info) => {
		if (!VITE_ENV || VITE_ENV.toUpperCase() === 'DEVELOPMENT') {
			console.log('Unhandled error:');
			console.log(err);
			console.log(vm);
			console.log(info);
			console.log(JSON.stringify({ err, vm, info }));
			alert('Unhandled error - please see console.');
		}
	};

	// attempt to auto refresh token before startup
	try {
		const authStore = useAuthStore();
		authStore.getTokenFromLocalStorage();
	} catch {
		// catch error to start app on success or failure
	}

	app.mount('#app');
}
